import { css } from "@emotion/react";

const boxWrapper = ({ theme }) => css`
  margin-bottom: 20px;

  border-top-left-radius: 0;
  border-top-right-radius: 0;

  padding-top: 0px;

  @media (min-width: ${theme.screenSizes.mdMax}) {
    margin-bottom: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding-top: 24px;
  }
`;

const divider = ({ theme }) => css`
  margin-bottom: 24px;

  @media (min-width: ${theme.screenSizes.mdMax}) {
    margin-bottom: 0;
    display: none;
  }
`;

export const addStyles = {
  boxWrapper,
  divider,
};
